import {Colors, hexToRGB} from '@wandb/common/css/globals.styles';
import styled from 'styled-components';

import {Icon as IconComp} from '../Icon';

type AlertProps = {
  severity: string;
};

const BG_COLORS: Record<string, string> = {
  default: hexToRGB(Colors.GRAY_900, 0.04),
  error: Colors.RED_LIGHT_TRANSPARENT,
  warning: Colors.GOLD_DARK_TRANSPARENT,
  info: Colors.TEAL_TRANSPARENT,
  success: Colors.GREEN_TRANSPARENT,
};

const TEXT_COLORS: Record<string, string> = {
  default: Colors.GRAY_800,
  error: Colors.RED,
  warning: Colors.GOLD_DARK2,
  info: Colors.TEAL_DARK,
  success: Colors.GREEN_DARK,
};

export const Alert = styled.div<AlertProps>`
  background-color: ${props => BG_COLORS[props.severity]};
  color: ${props => TEXT_COLORS[props.severity]};
  padding: 6px 16px;
  border-radius: 8px;
  font-size: 16px;
  font-weight: 400;
  line-height: 20px;
  display: flex;
  align-items: center;
`;

export const Icon = styled(IconComp)`
  font-size: 20px;
  margin-right: 8px;
  flex: 0 0 auto;
`;

export const Message = styled.div`
  // This value chosen to make the alert the same height as our source select widgets.
  padding: 3px;
  flex: 1 1 auto;
`;
